import { Component } from '@angular/core';
import { ItemViewContainerBase } from '@fi-app/core/item-view-container-base';
import { ClusterModel } from '../cluster.model';

@Component({
    selector: 'fi-cluster-view-container',
    template: `<fi-cluster-view [cluster]="cluster"></fi-cluster-view>`,
    styleUrls: ['./cluster-view-container.component.scss'],
    standalone: false,
})
export class ClusterViewContainerComponent extends ItemViewContainerBase {
    cluster: ClusterModel;
}
